/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type PCCProgram = typeof PCCProgram[keyof typeof PCCProgram];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PCCProgram = {
  CCM: 'CCM',
  RTM: 'RTM',
  Tempo: 'Tempo',
} as const;
